import type { AdminV2RecordActivityQuery } from "@/types/adminV2";

/**
 * Cache tags for a record's Activity tab (session 15, 07:40). Every Activity
 * read shares the timeline LIST tag; a user's also carries the user-wide
 * timeline tag that user writes invalidate (status change, internal note:
 * `app_user:<id>:all`), so a change made while Activity is open shows there.
 * Other record kinds have no record-wide timeline tag yet.
 */
export const getRecordActivityTags = (
  params: Pick<AdminV2RecordActivityQuery, "recordType" | "recordId">,
) => [
  { type: "AdminV2CrmTimeline" as const, id: "LIST" },
  ...(params.recordType === "user"
    ? [
        {
          type: "AdminV2CrmTimeline" as const,
          id: `app_user:${params.recordId}:all`,
        },
      ]
    : []),
];
